import fontBlackTtf from '@skodaflow/web-tokens/src/fonts/SKODANext-Black.ttf';
import fontBlackWoff from '@skodaflow/web-tokens/src/fonts/SKODANext-Black.woff';
import fontBlackWoff2 from '@skodaflow/web-tokens/src/fonts/SKODANext-Black.woff2';
import fontBoldTtf from '@skodaflow/web-tokens/src/fonts/SKODANext-Bold.ttf';
import fontBoldWoff from '@skodaflow/web-tokens/src/fonts/SKODANext-Bold.woff';
import fontBoldWoff2 from '@skodaflow/web-tokens/src/fonts/SKODANext-Bold.woff2';
import fontLightTtf from '@skodaflow/web-tokens/src/fonts/SKODANext-Light.ttf';
import fontLightWoff from '@skodaflow/web-tokens/src/fonts/SKODANext-Light.woff';
import fontLightWoff2 from '@skodaflow/web-tokens/src/fonts/SKODANext-Light.woff2';
import fontRegularTtf from '@skodaflow/web-tokens/src/fonts/SKODANext-Regular.ttf';
import fontRegularWoff from '@skodaflow/web-tokens/src/fonts/SKODANext-Regular.woff';
import fontRegularWoff2 from '@skodaflow/web-tokens/src/fonts/SKODANext-Regular.woff2';
import rtlFontBlackTtf from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Black.ttf';
import rtlFontBlackWoff from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Black.woff';
import rtlFontBlackWoff2 from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Black.woff2';
import rtlFontBoldTtf from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Bold.ttf';
import rtlFontBoldWoff from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Bold.woff';
import rtlFontBoldWoff2 from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Bold.woff2';
import rtlFontLightTtf from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Light.ttf';
import rtlFontLightWoff from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Light.woff';
import rtlFontLightWoff2 from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Light.woff2';
import rtlFontRegularTtf from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Regular.ttf';
import rtlFontRegularWoff from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Regular.woff';
import rtlFontRegularWoff2 from '@skodaflow/web-tokens/src/fonts/SKODANextArabic-Regular.woff2';

// fonts can be excluded from bundle by changing font import to undefined
export const fonts = {
  fontBlackTtf,
  fontBlackWoff,
  fontBlackWoff2,
  fontBoldTtf,
  fontBoldWoff,
  fontBoldWoff2,
  fontLightTtf,
  fontLightWoff,
  fontLightWoff2,
  fontRegularTtf,
  fontRegularWoff,
  fontRegularWoff2,
  rtlFontBlackTtf,
  rtlFontBlackWoff,
  rtlFontBlackWoff2,
  rtlFontBoldTtf,
  rtlFontBoldWoff,
  rtlFontBoldWoff2,
  rtlFontLightTtf,
  rtlFontLightWoff,
  rtlFontLightWoff2,
  rtlFontRegularTtf,
  rtlFontRegularWoff,
  rtlFontRegularWoff2,
};
